var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightOnButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.066,32.003C41.969,42.051,21.992,52.039,2.014,62.028    c-0.026-0.026-0.054-0.056-0.08-0.082c0.089-0.188,0.175-0.379,0.268-0.565c4.814-9.628,9.625-19.259,14.452-28.881    c0.186-0.371,0.177-0.643-0.007-1.007C11.82,21.869,7.008,12.24,2.194,2.61c-0.088-0.178-0.17-0.359-0.19-0.639    C21.986,11.963,41.971,21.955,62.066,32.003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightOnButton);
export default __webpack_public_path__ + "static/media/chevron-right-on-button.2880c28fe03e75e89e2dcc9ad5c56a48.svg";
export { ForwardRef as ReactComponent };